import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Card, CardContent, CollapseProvider, CollapseTrigger, Heading, Separator } from 'telia-front-react';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import { getInternetSpeed } from './InternetSpeedUtil';
import RequestFasterInternet from './RequestFasterInternet';

interface RequestFasterInternetWrapperProps {
  calculatorKey: string;
  internetCalculatorStore?: InternetCalculatorStore;
}

function RequestFasterInternetWrapper(props: RequestFasterInternetWrapperProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;
  const { internetCalculatorStore, calculatorKey } = props;

  if (!internetCalculatorStore.shouldShowRequestFasterInternet(calculatorKey)) {
    return null;
  }

  const hasSpeed500OrMore = !!internetCalculatorStore
    .getTeliaProductsWithoutPlannedNetwork(calculatorKey)
    .concat(internetCalculatorStore.getPartnerProductsWithoutPlannedNetwork(calculatorKey))
    .find((offer) => getInternetSpeed(offer) >= 500);

  return (
    <Card type="light" background="transparent">
      <CardContent>
        <div className="text-left">
          <Heading element="h4">
            {translate(hasSpeed500OrMore ? 'internetAndTvCalculator.wishFasterInternetWithCable' : 'internetAndTvCalculator.wishFasterInternet')}
          </Heading>
          <Separator spacing="xxsmall" color="invisible" />
          <p>{translate('internetAndTvCalculator.wishFasterInternet.info')}</p>
          <Separator spacing="xsmall" color="invisible" />
          <AnalyticsTrigger trigger={{ id: 'Link - Avaldan Soovi', callback: 'onToggle' }}>
            <CollapseProvider id="voteForFasterInternet">
              <CollapseTrigger>
                <Button className="text__margin-double" text={translate('internetAndTvCalculator.willVote')} variant="secondary" />
              </CollapseTrigger>
              <Separator spacing="xsmall" color="invisible" />
              <RequestFasterInternet partner={false} calculatorKey={calculatorKey} />
            </CollapseProvider>
          </AnalyticsTrigger>
        </div>
      </CardContent>
    </Card>
  );
}

export default inject('internetCalculatorStore')(observer(RequestFasterInternetWrapper));
